<ion-content class="ion-text-center modal">
  <rc-modal-header></rc-modal-header>
  <rc-item-scanner (onQrCodeScanned)="handleQrCodeScanned($event)"></rc-item-scanner>
</ion-content>
